export const ERROR_STRING = 'error_no_msg'

export const CONFERENCE_ID_SPECIAL = '15' // 特殊的活动id, 特殊处理 （不建议）



// WEBPACK FOOTER //
// ./src/utils/constant.js